import styled from 'styled-components';
import { Table, Input } from 'antd';

export const PoolTable = styled(Table)`
  .ant-table {
    .ant-table-thead {
      font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
      & > tr > th {
        color: ${props => props.theme.fontColors.thead};;
        letter-spacing: ${props => props.theme.letterSpacing.point6};
        background-color:#ffffff;
      }
    }
    .ant-table-header {
      background-color:#ffffff;
    }
    .ant-table-tbody {
      font-family: ${props => props.theme.fontFamily.helveticaNeue};
      & > tr > td {
       color: ${props => props.theme.fontColors.tbody};
        letter-spacing: ${props => props.theme.letterSpacing.point6};
      }
      & > tr > td > input {
          width: 100px;
          text-align: center !important;
          float: right;
          margin-right: 19px;
      }
    }
  }
`;

export const ExchangeFromTable = styled(PoolTable)`
  .ant-table-row:nth-child(2n + 1) {
      background-color: ${props => props.theme.backgroundColor.tableAltRowDark}!important;
    }
  }
  .ant-input-number {
    width: 100%!important;
    .ant-input-number-handler-wrap {
      display: none;
    }
  }
`;

export const FromTableFooter = styled.div`
  width: 70%;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.heading};
  letter-spacing: ${props => props.theme.letterSpacing.point6};
  align-items: center;
`;

export const TableInputWrapper = styled(Input)`
background-color: #f4f3f3;
`;

export const TotalSpan = styled.span`
  float: right;
  margin-right: 35px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold}
`;

export const HeaderStyle = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: 16px;
  letter-spacing: 0.6px;
  color: #505050;
`;

export const HeaderStyle2 = styled.div`
  font-family: HelveticaNeue !important;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0.6px;
  color: #505050;
`;

export const Triangle = styled.img`
margin: 0 0 3px 5px;
`;

export const InvestmentOption = styled.div`
font-family: HelveticaNeue;
font-size: 16px;
line-height: 1.38;
letter-spacing: 0.6px;
color: #006778;
padding-left: 4px;
`;

export const FooterWrapper = styled.div`
.ant-table-footer{
  padding: 16px 16px 16px 20px;
}
`;
